import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

const ShipmentsTable = ({ classes, data }) => {
  if (!data.length) return null;
  const currency = data.length ? data[0].currency : '';

  return (
    <Table className={classes.table}>
      <TableHead>
        <TableRow>
          <TableCell>Part Number</TableCell>
          <TableCell>Brand</TableCell>
          <TableCell>Description</TableCell>
          <TableCell>Reference</TableCell>
          <TableCell>Quantity</TableCell>
          <TableCell>Amount ({currency.trim()})</TableCell>
          <TableCell>Weight (kg)</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((value) => (
          <TableRow key={`${value.boxId}${value.portion}`}>
            <TableCell>{value.partNumber}</TableCell>
            <TableCell>{value.brand}</TableCell>
            <TableCell>{value.description}</TableCell>
            <TableCell>{value.yourReference}</TableCell>
            <TableCell>{value.quantity}</TableCell>
            <TableCell>{value.price}</TableCell>
            <TableCell>{value.weightKg}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default withStyles(styles)(ShipmentsTable);
